<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/StGuaV/tc-custom/9781467466844.jpg?1730408926764" alt="This image is the cover for the book New Testament Apocrypha, vol. 3"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">New Testament Apocrypha, vol. 3
      </h1>
      <p class="bookDescription body article font2">
        <b>An expansive compilation of New Testament apocrypha in English translation, featuring fascinating but heretofore unpublished texts. </b><br/>  <br/><i>New Testament Apocrypha, vol. 3</i>, continues to unearth the vast diversity of Christian Scripture outside of the traditional canon. This new collection encompasses a broad range of languages—Greek, Church Slavic, Old English, Coptic, and more—and spans centuries, from the formation of the canonical New Testament to the high Middle Ages.   <br/>   <br/> The selections here represent some of the least studied apocryphal texts, many of which have not previously received an English translation or a critical edition. Notable newly edited and translated selections include <i>The Martyrdom of Zechariah, The Decapitation of John the Forerunner, The Birth of John, The Revelation about the Lord’s Prayer, </i>and <i>The Dialogue of Mary and Christ on the Departure of the Soul.</i><br/>   <br/> Each text is accompanied by a robust introduction, bibliography, and notes. Scholars of apocrypha, Scripture, and hagiography from a breadth of disciplines will find this an indispensable reference for their research and teaching.<br/><br/><b>Contributors:</b><p> Carson Bay, Mark Glen Bilby, Rick Brannan, Christian H. Bull, Slavomir Čéplö, Alexander D’Alisera, J. Gregory Given, Nathan J. Hardy, Brandon W. Hawk, Stephen C. E. Hopkins, Alexander Kocar, Brent Landau, Jacob A. Lollar, Christine Luckritz Marquis, Ivan Miroshnikov, Tobias Nicklas, Samuel Osborn, Stephen Pelle, Bradley Rice, Julia A. Snyder, Janet E. Spittler, James Toma, Péter Tóth, Sarah Veale, J. Edward Walters, Charles D. Wright, Lorne R. Zelyck </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tony Burke
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Tony Burke</B>&#160;is professor of humanities at York University. His academic interests include the study of Christian biographical literature of the second century (infancy gospels), children and the family in Roman antiquity, curses, and noncanonical Jewish and Christian writings.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9ebc6b9a